import React from "react";

function Hero() {
  return (
    <header className="header">
      <div className="container">
        <div className="row">
          <div className="col-lg-11">
            <div className="text-container">
              <h1>Meet Your Match</h1>
              <p className="p-large p-heading">
                Swiperyt is a mobile application that connects individuals to
                their possible match using our qualified matching algorithm.
                It's the first app to harness the power of social connections to
                help you stay connected with the person of your choice.
              </p>
              <a className="btn-solid-lg" href="#your-link">
                <i className="fab fa-apple"></i>DOWNLOAD
              </a>
              <a className="btn-solid-lg" href="#your-link">
                <i className="fab fa-google-play"></i>DOWNLOAD
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-11">
            <div className="image-container">
              <img
                className="img-fluid"
                src="images/main-mockup.png"
                alt="alternative"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="deco-white-circle0">
        <img src="images/decorative-white-circle.svg" alt="alternative" />
      </div> */}
      <div className="deco-white-circle-1">
        <img src="images/decorative-white-circle.svg" alt="alternative" />
      </div>
      <div className="deco-blue-circle">
        <img src="images/decorative-blue-circle.svg" alt="alternative" />
      </div>
      <div className="deco-yellow-circle">
        <img src="images/decorative-yellow-circle.svg" alt="alternative" />
      </div>
      <div className="deco-green-diamond">
        <img src="images/decorative-green-diamond.svg" alt="alternative" />
      </div>
    </header>
  );
}

export default Hero;
